import { render, staticRenderFns } from "./DatosCompradoresComponent.vue?vue&type=template&id=eeb41470&scoped=true"
import script from "./DatosCompradoresComponent.vue?vue&type=script&lang=js"
export * from "./DatosCompradoresComponent.vue?vue&type=script&lang=js"
import style0 from "./DatosCompradoresComponent.vue?vue&type=style&index=0&id=eeb41470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb41470",
  null
  
)

export default component.exports